jQuery($ => {
    class AlignedStepsForm {
        constructor(element) {
            this._               = element;
            this._element        = $(element);
            this._form           = this._element.find('.o-aligned-steps-form__form');
            this._formPage       = this._element.find('.o-aligned-steps-form__form-page');
            this._currentPage    = this._element.find('.o-aligned-steps-form__form-page--active');
            this._steps          = this._element.find('.m-form-steps__item');
            this._mobileSteps    = this._element.find('.m-form-steps__mobile-item');
            this._previousButton = this._element.find('.o-aligned-steps-form__button-previous');
            this._nextButton     = this._element.find('.o-aligned-steps-form__button--next');
 
            this.init(); 
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger( 'init', this );

            this._element.on('validateForm', this._validateForm);

            this._previousButton.on('mousedown', this.navigateFormBackwards);
            this._previousButton.on('keydown', this.navigateFormBackwards);        
            
            this._nextButton.on('mousedown', this.navigateFormForwards);
            this._nextButton.on('keydown', this.navigateFormForwards);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ ValidateForm
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        validateForm = () => {
            this._form.validate({
                errorPlacement: (error, element) => {
                    error.insertAfter(element.closest(".o-aligned-steps-form__large-field"));
                },
                highlight: (element, errorClass, validClass) => {
                    $(element).closest(".o-aligned-steps-form__large-field").addClass("o-aligned-steps-form__large-field--error").removeClass("o-aligned-steps-form__large-field--valid");
                },
                unhighlight: (element, errorClass, validClass) => {
                    $(element).closest(".o-aligned-steps-form__large-field").removeClass("o-aligned-steps-form__large-field--error").addClass("o-aligned-steps-form__large-field--valid");
                },
                errorClass: "o-aligned-steps-form__error-message",
                errorElement: "p",
            });
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Navigate Form Backwards
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        navigateFormBackwards = () => {
            var currentPage = this._element.find('.o-aligned-steps-form__form-page--active'),
                index       = currentPage.index();

            this._steps.eq(index).removeClass('m-form-steps__item--current');
            this._steps.eq(index).prev().addClass('m-form-steps__item--current');

            this._mobileSteps.eq(index).removeClass('m-form-steps__mobile-item--current');
            this._mobileSteps.eq(index).prev().addClass('m-form-steps__mobile-item--current');

            currentPage.prev().addClass('o-aligned-steps-form__form-page--active');
            currentPage.removeClass('o-aligned-steps-form__form-page--active');
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Navigate Form Forwards
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
 
        navigateFormForwards = () => {
            var currentPage = this._element.find('.o-aligned-steps-form__form-page--active'),
                nextPage    = currentPage.next(),
                index       = currentPage.index();

 
            if ($('.m-large-radio-buttons__group[data-group-name="brand"')[0]) {
                var activeRB       = $('.m-large-radio-buttons__group[data-group-name="brand"').find("input:radio:checked"),
                    rBlasterButton = $('.m-large-radio-buttons__group[data-group-name="product_id"').find('.a-large-radio-button'),
                    rBlasterButton2 = $('.m-large-radio-buttons__group[data-group-name="collection_blaster"').find('.a-large-radio-button'),
                    activeVal      = activeRB.closest('.a-large-radio-button').data('brand-name'),
                    subheading     = $('.m-large-radio-buttons__group[data-group-name="product_id"').prev('.m-large-radio-buttons__subheading');

                rBlasterButton.css('display', 'none');
                rBlasterButton2.css('display', 'none');

                var length = $('.m-large-radio-buttons__group[data-group-name="product_id"').find(".a-large-radio-button[data-brand-name='" + activeVal + "']").length;

                if (length > 1) {
                    subheading.html(length + ' Blasters');
                } else {
                    subheading.html(length + ' Blaster');
                }
 
                $('.m-large-radio-buttons__group[data-group-name="product_id"').find(".a-large-radio-button[data-brand-name='" + activeVal + "']").css('display', 'flex');
                $('.m-large-radio-buttons__group[data-group-name="collection_blaster"').find(".a-large-radio-button[data-brand-name='" + activeVal + "']").css('display', 'flex');
            }

            this.validateForm();

            if (!this._form.valid()) return;

            this._steps.eq(index).addClass('m-form-steps__item--complete');

            this._steps.eq(index).removeClass('m-form-steps__item--current');
            this._steps.eq(index).next().addClass('m-form-steps__item--current');

            this._mobileSteps.eq(index).removeClass('m-form-steps__mobile-item--current');
            this._mobileSteps.eq(index).next().addClass('m-form-steps__mobile-item--current');

            nextPage.addClass('o-aligned-steps-form__form-page--active');

            this._formPage.eq(nextPage.index()).addClass('o-aligned-steps-form__form-page--active');

            currentPage.removeClass('o-aligned-steps-form__form-page--active');
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.aligned_steps_form = function() {
        var _ = this,
                opt = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                l = _.length, 
                i,
                ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].aligned_steps_form = new AlignedStepsForm(_[i], opt);
            else
                ret = _[i].aligned_steps_form[opt].apply(_[i].aligned_steps_form, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.o-aligned-steps-form').aligned_steps_form();
});